import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';

import { WeakPassword } from './WeakPassword';
import { AccountStatus } from './AccountStatus';
import { getShouldRenderAccStatusBlock, getShowAccountStatus } from '../../selectors';

const StatusChooser = ({ showAccStatus }) => (showAccStatus ? <AccountStatus /> : <WeakPassword />);

StatusChooser.propTypes = {
  showAccStatus: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  showAccStatus: getShowAccountStatus(state),
  shouldRender: getShouldRenderAccStatusBlock(state),
});

export default compose(
  connect(mapStateToProps),
  withRenderFlag,
)(StatusChooser);
